// SOHAT/frontend/src/App.js (نسخه اصلاح شده)

import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './assets/styles/global.css';

// Layout Components
import AdminLayout from './components/layout/AdminLayout';

// Page Components
import LoginPage from './pages/auth/LoginPage';
import TeacherDashboard from './pages/teacher/TeacherDashboard';
import AssignmentCreatePage from './pages/teacher/AssignmentCreatePage';
import AssignmentListPage from './pages/teacher/AssignmentListPage';
import StudentListPage from './pages/teacher/StudentListPage';
import CourseListPage from './pages/teacher/CourseListPage';
import CourseDetailPage from './pages/teacher/CourseDetailPage';
import TeacherStudentProgressPage from './pages/teacher/TeacherStudentProgressPage'; 
// ✅✅✅ فایل صفحه جدید نمره‌دهی ایمپورت شد
import AssignmentSubmissionsPage from './pages/teacher/AssignmentSubmissionsPage'; 
import GroupManagementPage from './pages/teacher/GroupManagementPage';
import GroupMembersPage from './pages/teacher/GroupMembersPage';
import TeacherLessonListPage from './pages/teacher/TeacherLessonListPage';
import TeacherDiscussionPage from './pages/teacher/TeacherDiscussionPage';
import StudentDashboard from './pages/student/StudentDashboard';
import AssignmentDetailPage from './pages/student/AssignmentDetailPage';
import LessonListPage from './pages/student/LessonListPage';
import LessonContentPage from './pages/student/LessonContentPage';
import GroupChatPage from './pages/student/GroupChatPage';
import AdminDashboard from './pages/admin/AdminDashboard';
import UserManagementPage from './pages/admin/UserManagementPage';


// (کامپوننت PrivateRoute بدون تغییر)
const PrivateRoute = ({ children, allowedRoles }) => {
    // ... (کد PrivateRoute بدون تغییر)
    const userRole = localStorage.getItem('userRole'); 
    
    if (!userRole) {
        return <Navigate to="/" replace />;
    }

    if (!allowedRoles.includes(userRole)) {
        switch (userRole) {
            case 'SchoolAdmin':
            case 'RegionAdmin':
            case 'DistrictAdmin':
            case 'CityAdmin':
            case 'ProvinceAdmin':
            case 'NationalAdmin':
                return <Navigate to="/admin/dashboard" replace />;
            case 'Teacher':
                return <Navigate to="/teacher/dashboard" replace />;
            case 'Student':
                return <Navigate to="/student/dashboard" replace />;
            default:
                return <Navigate to="/" replace />;
        }
    }
    
    return children;
};

function App() {
    const adminRoles = ['SchoolAdmin', 'RegionAdmin', 'DistrictAdmin', 'CityAdmin', 'ProvinceAdmin', 'NationalAdmin'];
    const teacherAdminRoles = [...adminRoles, 'Teacher'];
    return (
        <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
            <Routes>
                {/* --- مسیر عمومی ورود --- */}
                <Route path="/" element={<LoginPage />} />

                {/* --- مسیرهای محافظت‌شده برای مدیران و معلمان --- */}
                <Route 
                    element={
                        <PrivateRoute allowedRoles={[...adminRoles, 'Teacher']}>
                            <AdminLayout />
                        </PrivateRoute>
                    }
                >
                    {/* مسیرهای معلم */}
                    <Route path="/teacher/dashboard" element={<TeacherDashboard />} />
                    <Route path="/teacher/assignments" element={<AssignmentListPage />} />
                    <Route path="/teacher/assignments/create" element={<AssignmentCreatePage />} />
                    <Route path="/teacher/students" element={<StudentListPage />} />
                    <Route path="/teacher/courses" element={<CourseListPage />} />
                    <Route path="/teacher/courses/:courseId" element={<CourseDetailPage />} />
                    <Route path="/teacher/courses/:courseId/groups" element={<GroupManagementPage />} />
                    <Route path="/teacher/student-progress/:studentId" element={<TeacherStudentProgressPage />} />
                    {/* ✅✅✅ مسیرهای جدید برای تالار گفتگوی معلم */}
                    <Route path="/teacher/courses/:courseId/lessons" element={<TeacherLessonListPage />} />
                    <Route path="/teacher/lesson/:lessonId/discussion" element={<TeacherDiscussionPage />} />
                    {/* ✅✅✅ مسیر جدید برای مشاهده پاسخ‌های یک تکلیف */}
                    <Route path="/teacher/assignment/:assignmentId/submissions" element={<AssignmentSubmissionsPage />} />
                    {/* ✅✅✅ مسیر جدید برای مدیریت اعضای گروه */}
                    <Route path="/teacher/groups/:groupId/members" element={<GroupMembersPage />} />
                    {/* مسیرهای مدیران */}
                    <Route path="/admin/dashboard" element={<AdminDashboard />} />
                    <Route path="/admin/users" element={<UserManagementPage />} />
                </Route>

                {/* --- مسیرهای محافظت‌شده برای دانش‌آموزان --- */}
                {/* ... (مسیرهای دانش‌آموزان بدون تغییر) ... */}
                <Route 
                    path="/student/dashboard" 
                    element={
                        <PrivateRoute allowedRoles={['Student']}>
                            <StudentDashboard />
                        </PrivateRoute>
                    } 
                />
                
                <Route 
                    path="/student/assignment/:assignmentId" 
                    element={
                        <PrivateRoute allowedRoles={['Student']}>
                            <AssignmentDetailPage />
                        </PrivateRoute>
                    } 
                />
                
                <Route 
                    path="/student/courses/:courseId/lessons/" 
                    element={
                        <PrivateRoute allowedRoles={['Student']}>
                            <LessonListPage />
                        </PrivateRoute>
                    } 
                />

                <Route 
                    path="/student/content/:lessonId" 
                    element={
                        <PrivateRoute allowedRoles={['Student']}>
                            <LessonContentPage />
                        </PrivateRoute>
                    } 
                />
                
                <Route 
                    path="/student/group-chat/:groupId" 
                    element={<PrivateRoute allowedRoles={['Student']}><GroupChatPage /></PrivateRoute>} 
                />
                <Route 
                    path="/chat/group/:groupId" 
                    element={
                        <PrivateRoute allowedRoles={['Student', 'Teacher', ...adminRoles]}>
                            <GroupChatPage />
                        </PrivateRoute>
                    } 
                />

                {/* --- مسیر جایگزین --- */}
                <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
        </Router>
    );
}

export default App;